import React from 'react';
import _ from 'lodash';

import { Row, Col, Collapse } from 'antd';

import { CustomerFacility } from '../../../../../../api-client';

import './bv-customer-facilities.scss';

import BVEmpty from '../../../../../../common/components/BVEmpty/bv-empty';

const {
    Panel
} = Collapse;

interface IBVCustomerFacilities {
    facilities?: CustomerFacility[];
}

const BVCustomerFacilities: React.FunctionComponent<IBVCustomerFacilities> = ({ facilities }) => (
    <div className="bv-customer-facilities-container">
        <Collapse ghost defaultActiveKey={[]} expandIconPosition={'right'}>
            <Panel key="1" className="customer-facility-panel" header="Ship to">
                <BVEmpty dataSource={facilities || []} disclaimer={'No ship to found for selected customer.'}>
                    <Row gutter={[16, 16]}>
                        {_.map(facilities?.filter(facility => facility?.ecc), (dataItem, dataIndex) => (
                            <Col key={dataIndex} span={6}>
                                <div className="customer-facility-card">
                                    <span className="facility-card-heading">
                                        {dataItem.name}
                                    </span>
                                    <span className="facility-card-secondary-heading">
                                        {dataItem.address}
                                    </span>
                                    <span className="facility-card-secondary-heading">
                                        {`${dataItem.city} ${dataItem.zipCode}`}
                                    </span>
                                    <span className="facility-card-secondary-heading">
                                        {`${dataItem.country?.name} (${dataItem.country?.code})`}
                                    </span>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </BVEmpty>
            </Panel>
        </Collapse>
    </div>
);

export default BVCustomerFacilities;